/**
 * Nsection B9 Service
 * B.9.額外性的證明 API 服務
 */

import axios from '../api/axios';

const BASE_URL = '/api/nsection-b9';

export interface NsectionB9Detail {
  id: number;
  organization_id: number;
  proposal_id: number;
  additionality_approach: string | null;
  regulatory_analysis: string | null;
  locking_in_avoidance: string | null;
  investment_analysis: string | null;
  barrier_analysis: string | null;
  common_practice_analysis: string | null;
  performance_approach: string | null;
  nsection_b9_pct: number;
  edit_by: number;
  created_at: string;
  updated_at: string | null;
}

export interface NsectionB9Update {
  additionality_approach?: string;
  regulatory_analysis?: string;
  locking_in_avoidance?: string;
  investment_analysis?: string;
  barrier_analysis?: string;
  common_practice_analysis?: string;
  performance_approach?: string;
}

const nsectionB9Service = {
  getByProposal: async (proposalId: number): Promise<NsectionB9Detail | null> => {
    const response = await axios.get(`${BASE_URL}/by-proposal/${proposalId}`);
    return response.data;
  },
  update: async (proposalId: number, data: NsectionB9Update): Promise<NsectionB9Detail> => {
    const response = await axios.put(`${BASE_URL}/${proposalId}`, data);
    return response.data;
  },
};

export default nsectionB9Service;
